// tslint:disable-next-line:variable-name
export var FieldType = {
    Simple: 'SIMPLE',
    Parent: 'PARENT',
    Array: 'ARRAY',
};
//# sourceMappingURL=typings.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/yarfl/es/typings.js
// module id = 109
// module chunks = 0